// src/components/Header.tsx
import React from "react";
import "../../assets/styles/Header.css";

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-container">
        <h1 className="brand">LavernAI</h1>
      </div>
    </header>
  );
};

export default Header;
